import '../../styles/sections/collection-main.scss';

import { addToCart } from '../utils/cart';
class SimpleProduct extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[data-add-to-cart]');
    this.variantId = this.querySelector('[data-variant-id]').value;

    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.addToCart(this.form);
    })
  }

  async addToCart(form) {
    if (form.dataset.trainer) {
      localStorage.setItem('trainer', form.dataset.trainer);
    }

    const formData = new FormData(form);

    await addToCart(this.variantId, 1, formData.get('selling_plan'));
  }
}

try {
  customElements.define('simple-product', SimpleProduct);
}
catch(e) {
  console.log("product-card already defined", e)
}
